import { Grid, Typography } from "@mui/material"

const Mantenimiento = () => {
    return (
        <>
            <Grid container flexDirection='row' sx={{ alignItems: 'center' }} spacing={8}>
                <Grid item xs={4}>
                    <img src="./images/tucan.png" alt="tucan" width='100%' />
                </Grid>
                <Grid item xs={8}>
                    <Typography variant='h4' className="freestyle mantenimiento">
                        Pronto más información
                    </Typography>
                </Grid>
            </Grid>
        </>
    )
}

export default Mantenimiento